{
  "loading": "Caricamento...",
  "placeholder": "Seleziona un’opzione..."
}
